import { useTranslations } from 'next-intl';

import Button from '../button/Button';
import { ButtonStyle } from '../button/ButtonStyle.enum';

import Modal, { ModalProps } from './Modal';

type NoOnlineTicketUrlModalProps = ModalProps;

export function NoOnlineTicketUrlModal(props: NoOnlineTicketUrlModalProps) {
    const t = useTranslations();

    return (
        <Modal
            {...props}
            onClose={null}
            title={t('program.no-online-ticketing-link.title')}>
            <div className="flex flex-col space-y-36">
                <span>{t('program.no-online-ticketing-link.text')}</span>
                <Button
                    style={ButtonStyle.frameless_on_white_bg}
                    onClick={() => props.setModalIsOpen?.(false)}>
                    {t('common.ok')}
                </Button>
            </div>
        </Modal>
    );
}
